import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../components/common/Banner';
import CourseCategories from '../components/courses/CourseCategories';
import CourseFilter from '../components/courses/CourseFilter';
import FeaturedCourseSection from '../components/courses/FeaturedCourseSection';
import CourseGrid from '../components/courses/CourseGrid';
import EnrollmentProcess from '../components/courses/EnrollmentProcess';
import TestimonialSlider from '../components/common/TestimonialSlider';
import styled from 'styled-components';
import Button from '../components/common/Button';

const CTASection = styled.section`
  background-color: ${props => props.theme.colors.primaryColor};
  padding: 80px 0;
  text-align: center;
  color: white;
`;

const CTATitle = styled.h2`
  color: white;
  font-size: ${props => props.theme.fontSizes.xxxlarge};
  margin-bottom: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
`;

const CTADescription = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.regular};
  }
`;

const CTAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 0 auto;
  }
`;

const CoursesPage = () => {
  return (
    <>
      <Helmet>
        <title>Courses - KALS Academy</title>
        <meta name="description" content="Explore our comprehensive range of courses in structural engineering, civil engineering, exam preparation, and software training." />
      </Helmet>
      
      <Banner title="Our Courses" />
      <CourseCategories />
      <CourseFilter />
      <FeaturedCourseSection />
      <CourseGrid />
      <EnrollmentProcess />
      <TestimonialSlider 
        title="What Our Students Say" 
        subtitle="Hear from those who have experienced our training programs" 
      />
      
      <CTASection>
        <div className="container">
          <CTATitle>Ready to Advance Your Career?</CTATitle>
          <CTADescription>
            Join KALS Academy today and take the first step towards a successful career in engineering.
          </CTADescription>
          <CTAButtons>
            <Button to="/contact" variant="primary" 
              style={{ backgroundColor: 'white', color: '#3498db' }}
              >
              Enroll Now
            </Button>
            <Button variant="outline" outline="primary"
              style={{ borderColor: 'white', color: 'white' }}
              >
              Download Course Catalog
            </Button>
          </CTAButtons>
        </div>
      </CTASection>
    </>
  );
};

export default CoursesPage;